module.exports = __webpack_public_path__ + "assets/img/37_1017_big.97b2acd4.jpg";